
class AgileAtomInsight {
  constructor(element, ...options) {
    this.defaults = {
      isotopeGridSelector: '.js-atoms-grid',
      showFilterSelector: '.js-atoms-show-filter',
      resetFilterSelector: '.js-atoms-reset-filter',
      filterWrapperSelector: '.js-atoms-filter-wrapper',
      filterGroupSelector: '.js-atoms-filter-group',
      filterItemSelector: '.js-atoms-filter-item',
      filterInfoSelector: '.js-atoms-filter-info',
      filterShowGroup: '.show-group-',
      showMoreSelector: '.js-atoms-show-more',
      filteredClass: '-is-filtered',
      activeClass: '-is-active',
      inactiveClass: '-is-inactive',
      gridOptions: {},
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    this.isotopeGridElement = this.element.querySelector(this.options.isotopeGridSelector);
    this.showFilterElement = this.element.querySelector(this.options.showFilterSelector);
    this.resetFilterElement = this.element.querySelector(this.options.resetFilterSelector);
    this.filterWrapperElement = this.element.querySelector(this.options.filterWrapperSelector);
    this.showMoreElement = this.element.querySelector(this.options.showMoreSelector);
    this.filterGroupElements = [].slice.call(this.element.querySelectorAll(this.options.filterGroupSelector));
    this.filterItemElements = [].slice.call(this.element.querySelectorAll(this.options.filterItemSelector));
    this.filterInfoElement = this.element.querySelector(this.options.filterInfoSelector);
    this.filterValues = {};
    this.filtered = false;

    this.showGroupFilter = {
      filterShowGroup: ['.show-group-'],
      showGroups: [0]
    };

    this.options.gridOptions.filter = this.buildFilter(this.showGroupFilter);
    this.grid = new IsotopeGrid(this.isotopeGridElement, this.options.gridOptions);

    this.initFilterValues();
    this.bindEvents();
  }

  initFilterValues() {
    this.filterGroupElements.forEach((el) => {
      this.filterValues[el.dataset.group] = [];
    });
  }

  toggleFilterValue(event) {
    // prevent double event trigger from checkbox and label
    if(event.target.nodeName === 'LABEL') return;

    const tar = event.currentTarget;
    const filterValue = tar.dataset.filter || '';
    const filterGroup = tar.parentNode.dataset.group || '';

    if (tar.classList.contains(this.options.activeClass)) {
      this.filterValues[filterGroup] = this.filterValues[filterGroup].filter(item => item !== filterValue);
    } else {
      this.filterValues[filterGroup].push(filterValue);
    }

    tar.classList.toggle(this.options.activeClass);
    if(tar.classList.contains('checkbox-wrapper')) this.setCheckbox(tar);

    this.checkIsFiltered();
    this.toggleShowMore();
    this.updateGrid(this.filterValues);
    this.updateFilterInfo();
  }

  setCheckbox(tar) {
    tar.querySelector('input').checked = tar.classList.contains(this.options.activeClass);
  }

  combine([head, ...[headTail, ...tailTail]]) {
    if (!headTail) return head;

    const combined = headTail.reduce((acc, x) => {
      return acc.concat(head.map(h => `${h}${x}`));
    }, []);

    return this.combine([combined, ...tailTail]);
  }

  buildFilter(filterValues) {
    return this.combine(Object.values(filterValues).filter(arr => arr.length));
  }

  checkIsFiltered() {
    // if some filters are set
    for(let i = 0; i < Object.keys(this.filterValues).length; i += 1) {
      if(Object.values(this.filterValues)[i].length > 0) {
        this.element.classList.add(this.options.filteredClass);
        this.filtered = true;
        return;
      }
    }

    this.element.classList.remove(this.options.filteredClass);
    this.filtered = false;
  }

  updateGrid(filterValues) {
    const filter = this.buildFilter(filterValues);
    this.grid.iso.arrange({
      filter: (filter && filter.length) ?
        filter :
        this.buildFilter(this.showGroupFilter)
    });
  }

  updateFilterInfo() {
    let info = '';

    if(this.filtered) {
      const count = this.grid.iso.filteredItems.length;
      const countAppendix = (count === 1) ? 'Ergebnis' : 'Ergebnisse';

      const filterNames = [];
      this.filterItemElements.forEach((el) => {
        if(el.classList.contains(this.options.activeClass)) {
          filterNames.push(el.innerHTML.replace(/(<([^>]+)>)/ig,"").trim());
        }
      });

      info = `${count} ${countAppendix} für: ${filterNames.join(', ')}`;
    }

    this.filterInfoElement.innerHTML = info;
  }

  showMore() {
    this.showGroupFilter.showGroups.push(this.showGroupFilter.showGroups.length);
    this.toggleShowMore();
    this.updateGrid(this.showGroupFilter);
  }

  toggleShowMore() {
    if(this.showMoreElement) {
      // if all elements already shown
      if(parseInt(this.grid.iso.items.length/12) < this.showGroupFilter.showGroups.length) {
        this.showMoreElement.classList.add(this.options.inactiveClass);
        return;
      }

      // if some filters are set
      if(this.filtered) {
        this.showMoreElement.classList.add(this.options.inactiveClass);
        return;
      }

      // else display show more button
      this.showMoreElement.classList.remove(this.options.inactiveClass);
    }
  }

  toggleShowFilter() {
    if (this.filterWrapperElement.style.maxHeight) {
      this.filterWrapperElement.style.maxHeight = null;
      this.showFilterElement.classList.remove(this.options.activeClass);
    } else {
      this.filterWrapperElement.style.maxHeight = `${this.filterWrapperElement.scrollHeight}px`;
      this.showFilterElement.classList.add(this.options.activeClass);
    }
  }

  resetFilter() {
    this.initFilterValues();

    this.filterItemElements.forEach((el) => {
      el.classList.remove(this.options.activeClass);
      if(el.classList.contains('checkbox-wrapper')) this.setCheckbox(el);
    });

    this.checkIsFiltered();
    this.toggleShowMore();
    this.updateGrid(this.filterValues);
  }

  bindEvents() {
    this.showFilterElement.addEventListener('click', this.toggleShowFilter.bind(this));
    this.resetFilterElement.addEventListener('click', this.resetFilter.bind(this));
    this.filterItemElements.forEach((item) => {
      item.addEventListener('click', this.toggleFilterValue.bind(this));
    });
    if(this.showMoreElement) {
      this.showMoreElement.addEventListener('click', this.showMore.bind(this));
    }
  }
}
